export const TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SELECT_ONE: 'select-one',
  SELECT_MANY: 'select-many',
  DATE: 'date',
  TEXT: 'text',
  LABEL: 'label',
  LIST: 'list',
  BUTTON: 'button',
  SELECT: 'combobox',
  COUNTRY_SELECT: 'countrySelector',
  UPLOAD_FILE: 'uploadFile',
  SEPARATOR: 'separator',
  INCLUDE: 'include',
  MULTIPLIER: 'multiplier'
};

export const MOBILE_FULLSCREEN_IGNORE_TYPES = ['radio', 'checkbox'];

export const IGNORE_DATA_TYPES = ['separator', 'label', 'title'];

export const SHARED_GRID_COL_TYPES = ['radio', 'checkbox'];

export const SHARED_MIN_GRID = 1;

export const GRID = 12;
